import Module from './Module';
import Components from '../../components/Components';
import BootstrapComponent from '../../components/BootstrapComponent';
import * as log from 'loglevel';

/**
 * This Module create {@link Components}
 * 
 * @extends Module
 * @category bootstrap
 * @author Geoffrey Mayeux
 */
class ComponentsModule extends Module{
	constructor(bootstrap){
		super(bootstrap);
		this.selector = 'html';
	}

	get priority(){
		return -2;
	}

	build(){
		this._components = new Components(this.selector);
		this._components.creator = (clazz, element) => {
			if(clazz.prototype instanceof BootstrapComponent)
				return new clazz(element, this.bootstrap);
			return new clazz(element);
		};
	}

	get selector(){ return this._selector; }
	set selector(selector){
		if(this._selector != selector){
			this._selector  = selector;
			this.build();
		}
	}

	get components(){
		if(!this._components)
			this.build();
		return this._components;
	}

	get(element){
		return this.components.get(element);
	}

	register(components){
		log.debug('register', components);
		this.components.register(components);
	}

	async run(){
		let components = await this.components.setup();
	}
}

export default ComponentsModule;
export { ComponentsModule };